<p-dialog
        header="GDV-Schema einrichten"
        [(visible)]="visible"
        (visibleChange)="visibleChange.emit($event)"
        [modal]="true"
        [closable]="!busy"
        [closeOnEscape]="!busy"
        [dismissableMask]="false"
        styleClass="w-30rem md:w-40rem"
        [draggable]="false"
        [resizable]="false">

    <div class="flex flex-column gap-4">

        <!-- EmSchemaType picker -->
        <div class="flex flex-column gap-2">
            <label for="hgSchemaTypeId" class="font-semibold">
                Schema-Typ <span class="text-red-500">*</span>
            </label>
            <p-select id="hgSchemaTypeId"
                      [options]="schemaTypeOptions"
                      [(ngModel)]="schemaTypeId"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Schema-Typ auswählen"
                      [filter]="true"
                      filterPlaceholder="Suchen..."
                      [disabled]="busy || schemaTypesLoading"
                      [loading]="schemaTypesLoading"
                      styleClass="w-full">
            </p-select>
        </div>

        <!-- Include non-data message types -->
        <div class="flex flex-column gap-2">
            <div class="flex align-items-center gap-2">
                <p-checkbox inputId="hgIncludeNonData"
                            [(ngModel)]="includeNonDataMessageTypes"
                            [binary]="true"
                            [disabled]="busy">
                </p-checkbox>
                <label for="hgIncludeNonData" class="cursor-pointer">
                    Nicht-Daten-Nachrichtentypen einschließen (HANDBOOK / FAQ)
                </label>
            </div>
            <small class="text-500">
                Nur aktivieren, wenn das Schema auch Handbuch- und FAQ-Strukturen enthalten soll.
                Standard: aus (nur die zusammengeführte GDV-Gesamtstruktur).
            </small>
        </div>

        <!-- Extension schema file upload (optional) -->
        <div class="flex flex-column gap-2">
            <label class="font-semibold">
                <i class="fa-regular fa-file-code mr-2"></i>
                Erweiterungsschema (XML) — optional
            </label>

            @if (!selectedFile) {
                <p-fileupload
                        name="extensionFile"
                        mode="basic"
                        chooseLabel="XML-Datei auswählen"
                        chooseIcon="fa-regular fa-upload"
                        accept=".xml,application/xml"
                        [multiple]="false"
                        [auto]="false"
                        [customUpload]="true"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        [disabled]="busy"
                        (onSelect)="onFileSelect($event)">
                </p-fileupload>
            }

            @if (selectedFile) {
                <div class="surface-100 border-round p-3 flex align-items-center gap-2">
                    <i class="fa-regular fa-file text-primary"></i>
                    <span class="font-semibold">{{ selectedFile.name }}</span>
                    <span class="text-500 text-sm">({{ (selectedFile.size / 1024).toFixed(1) }} KB)</span>
                    <div class="ml-auto">
                        <p-button icon="fa-regular fa-trash"
                                  severity="danger"
                                  [text]="true"
                                  [disabled]="busy"
                                  (click)="clearFile()">
                        </p-button>
                    </div>
                </div>
            }

            <small class="text-500">
                Leer lassen für das Standard-GDV-Schema. Mit Datei wird ein zusammengeführtes Schema erzeugt
                und ein vorhandenes Schema ersetzt.
            </small>
        </div>

        <!-- Organization name (optional) -->
        <div class="flex flex-column gap-2">
            <label for="hgOrganizationName" class="font-semibold">
                Organisationsname (optional)
            </label>
            <input id="hgOrganizationName"
                   type="text"
                   pInputText
                   [(ngModel)]="organizationName"
                   [disabled]="busy"
                   placeholder="z. B. Partnername"/>
            <small class="text-500">
                Wird im erzeugten Schema-Eintrag gespeichert. Standard: Partnername.
            </small>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button label="Abbrechen"
                      icon="fa-regular fa-xmark"
                      severity="secondary"
                      [text]="true"
                      [disabled]="busy"
                      (click)="cancel()">
            </p-button>
            <p-button label="Speichern"
                      icon="fa-regular fa-check"
                      [loading]="busy"
                      [disabled]="!canSubmit"
                      (click)="submit()">
            </p-button>
        </div>
    </ng-template>

</p-dialog>
